// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
// import store from './vuex/store';
import store from './store';
import './permission' // permission control
// 引入icon
import './assets/icon/iconfont.css'
import './assets/icon/time/iconfont'
// import {DICT_TYPE,getDictDataLabel, getDictDatas, getDictDatas2} from "./utils/dict";
// {/* <script src="../../assets/icon/time/iconfont.js"></script> */}
// //
// Vue.prototype.getDictDatas = getDictDatas
// Vue.prototype.getDictDatas2 = getDictDatas2
// Vue.prototype.getDictDataLabel = getDictDataLabel
// Vue.prototype.DICT_TYPE = DICT_TYPE
4
import directive from './directive' // directive
Vue.use(directive)

//tree
import '@/assets/styles/ruoyi.css'
import {handleTree,resetForm} from "@/utils/ruoyi";
Vue.prototype.handleTree = handleTree
Vue.prototype.resetForm = resetForm


// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)


// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: 'K1vdYnxesH3PX7l4fZ5UOSW0BLnZqZ6a'
})

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})




// WEBPACK FOOTER //
// ./src/main.js